import axios from 'axios';
export const LOADING = 'LOADING';
export const DOCUMENT_TYPE_FILTER = 'DOCUMENT_TYPE_FILTER';
export const FETCH_ORDER_HISTORY = 'FETCH_ORDER_HISTORY';
export const FETCH_ADHERENCE_HISTORY = 'FETCH_ADHERENCE_HISTORY';
export const ADHERENCE_HISTORY_PAGINATION = 'ADHERENCE_HISTORY_PAGINATION';
export const UPLOAD_USER_IMAGE = 'UPLOAD_USER_IMAGE';
export const GET_PROFILE_FORM = 'GET_PROFILE_FORM';
export const GET_EMAIL_PREFERENCES = 'GET_EMAIL_PREFERENCES';
export const FETCH_BOOKMARKS = 'FETCH_BOOKMARKS';

export function documentTypeFilter( document_type_slug ) {
	return ( dispatch ) => {
		dispatch( {
			          type: DOCUMENT_TYPE_FILTER, payload: document_type_slug
		          } );
		};
}

export function getOrderHistory() {
	return (dispatch) => {
		dispatch({
			type: LOADING, payload: true,
		});
		const url = `${wpApiSettings.root}isda/v1/order/order-history`;
		axios.get(url, get_config()).then(response => {
			dispatch({
				type: FETCH_ORDER_HISTORY, payload: response.data,
			});
			dispatch({
				type: LOADING, payload: false,
			});
		});
	};
}

export function getProfileForm() {
	return (dispatch) => {
		dispatch({
			type: LOADING, payload: true,
		});
		const url = `${wpApiSettings.root}isda/v1/account/profile-form`;
		axios.get(url, get_config()).then(response => {
			dispatch({
				type: GET_PROFILE_FORM, payload: response.data,
			});
		}).catch(error => {
			console.log(error);
		}).finally(() => {
			dispatch({
				type: LOADING, payload: false,
			});
		});
	};
}

export function getEmailPreferences() {
	return (dispatch) => {
		dispatch({
			type: LOADING, payload: true,
		});
		const url = `${wpApiSettings.root}isda/v1/account/email-preferences`;
		axios.get(url, get_config()).then(response => {
			dispatch({
				type: GET_EMAIL_PREFERENCES, payload: response.data,
			});
		}).catch(error => {
			console.log(error);
		}).finally(() => {
			dispatch({
				type: LOADING, payload: false,
			});
		});
	};
}

export function uploadUserImage( image ) {
	return (dispatch) => {
		const url = `${wpApiSettings.root}isda/v1/account/upload-user-image`;
		const formData = new FormData();
		formData.append('image', image);
		return axios.post(url, formData, get_config()).then(response => {
			if (response.status !== 200) {
				dispatch({
					type: UPLOAD_USER_IMAGE, payload: false,
				});
			} else {
				dispatch({
					type: UPLOAD_USER_IMAGE, payload: true,
				});
			}
			return response.data;
		}).catch(error => {
			dispatch({
				type: UPLOAD_USER_IMAGE, payload: false,
			});
		
		});
	};
}

export function getOrdersHistory( pageNum, tabType, limit ) {
	return (dispatch) => {
		dispatch({
			type: LOADING, payload: true,
		});
		const url = `${wpApiSettings.root}isda/v1/order/adherence-history?pageNum=${pageNum}&type=${tabType}&limit=${limit}`;
		axios.get(url, get_config()).then(response => {

			dispatch({
				type: FETCH_ADHERENCE_HISTORY,
				payload: {
					tabType,
					data: response.data.data,
				}
			});


			dispatch({
				type: ADHERENCE_HISTORY_PAGINATION,
				payload: {
					tabType,
					nextPage: response.data.pagination.next_page ? response.data.pagination.next_page : 0
				}
			});

		}).catch(error => {
			console.log(error);
		}).finally(() => {
			dispatch({
				type: LOADING, payload: false,
			});
		});
	};
}

export function getBookmarks() {
	return ( dispatch ) => {
		const url = `${ wpApiSettings.root }isda/v1/account/full-bookmarks`;
		axios.get( url, get_config() ).then( response => {
			dispatch( {
				          type: FETCH_BOOKMARKS, payload: response.data
			          } );
		} );
	};
}


function get_config() {
	let config = {
		headers: {
			'X-WP-Nonce': wpApiSettings.nonce
		}
	};
	return config;
}